var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarquise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 37,
    height: 58
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8218 11.9785H21.1785V68.0212H57.8218V11.9785Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4999 67.8073C39.3835 67.8073 39.2673 67.7787 39.1509 67.7073C14.4167 51.4032 20.8874 33.6987 26.951 24.582C32.1277 16.7944 38.8746 12.4647 39.1653 12.2931C39.4563 12.1076 39.8344 12.1931 40.0234 12.4789C40.2125 12.7648 40.1252 13.1364 39.8344 13.322C39.7615 13.3649 33.0291 17.6946 27.9833 25.2537C14.4458 45.6017 29.5976 59.9482 39.8488 66.7069C40.1396 66.8928 40.2125 67.2641 40.0234 67.55C39.907 67.7215 39.7033 67.8216 39.5143 67.8216L39.4999 67.8073Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 67.807C39.2965 67.807 39.1075 67.707 38.9911 67.5354C38.8021 67.2638 38.8747 66.8782 39.1655 66.6924C49.4023 59.9478 64.5541 45.5869 51.0166 25.2391C45.9708 17.68 39.2237 13.3503 39.1655 13.3074C38.8747 13.1216 38.8021 12.7502 38.9764 12.4644C39.1655 12.1785 39.5436 12.1072 39.8346 12.2785C40.1253 12.4643 46.8578 16.7796 52.0488 24.5674C58.1125 33.6696 64.5832 51.3884 39.849 67.6925C39.7473 67.7641 39.6309 67.7925 39.5 67.7925V67.807Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5002 53.0034C39.3693 53.0034 39.2385 52.9605 39.1365 52.8891L33.2331 48.5738C33.1311 48.5023 33.0585 48.4023 33.0149 48.288L30.1794 40.2002C30.1358 40.0573 30.1358 39.9144 30.1794 39.7715L33.1893 32.4268C33.2331 32.3126 33.3201 32.2124 33.4221 32.141L39.1512 28.4687C39.4275 28.2829 39.82 28.3687 40.0091 28.6401C40.1981 28.9259 40.1108 29.2975 39.8347 29.4833L34.2653 33.0412L31.4153 40.0002L34.1201 47.7021L39.8782 51.9032C40.1546 52.1032 40.2128 52.4891 40.0091 52.7462C39.8927 52.9033 39.7036 52.9891 39.5146 52.9891L39.5002 53.0034Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4999 53.0035C39.3108 53.0035 39.1218 52.9177 39.0054 52.7606C38.8019 52.4892 38.8601 52.1176 39.1364 51.9176L44.8946 47.7165L47.5991 40.0145L44.7491 33.0558L39.18 29.4977C38.8892 29.3119 38.8164 28.9403 39.0054 28.6545C39.1944 28.3689 39.5725 28.2973 39.8635 28.4831L45.5926 32.1554C45.6943 32.227 45.7816 32.327 45.8251 32.4412L48.8353 39.7859C48.8933 39.9288 48.8933 40.0717 48.8353 40.2146L45.9997 48.3024C45.956 48.4166 45.8833 48.5167 45.7816 48.5882L39.8779 52.9035C39.7615 52.9893 39.6307 53.018 39.5143 53.018L39.4999 53.0035Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7561 33.2553C33.5962 33.2553 33.4362 33.1982 33.3198 33.0837L26.3839 26.3534C26.1367 26.1105 26.1367 25.7391 26.3839 25.4962C26.6311 25.2532 27.0092 25.2532 27.2562 25.4962L34.1924 32.2265C34.4396 32.4694 34.4396 32.8408 34.1924 33.0837C34.076 33.1982 33.9161 33.2695 33.7561 33.2695V33.2553Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7461 40.6149H22.0359C21.7016 40.6149 21.4253 40.3434 21.4253 40.0146C21.4253 39.6861 21.7016 39.4146 22.0359 39.4146H30.7461C31.0804 39.4146 31.3567 39.6861 31.3567 40.0146C31.3567 40.3434 31.0804 40.6149 30.7461 40.6149Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6023 55.8183C26.4424 55.8183 26.2969 55.7612 26.1805 55.6469C25.9335 55.4182 25.9335 55.0324 26.1661 54.7895L33.1458 47.6591C33.3783 47.4162 33.7711 47.4162 34.0181 47.6449C34.2653 47.8734 34.2653 48.2592 34.0328 48.5021L27.0531 55.6325C26.9367 55.7612 26.7767 55.8183 26.6023 55.8183Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4998 67.2347C39.1653 67.2347 38.8892 66.9631 38.8892 66.6346V52.8882C38.8892 52.5595 39.1653 52.2881 39.4998 52.2881C39.8343 52.2881 40.1105 52.5595 40.1105 52.8882V66.6346C40.1105 66.9631 39.8343 67.2347 39.4998 67.2347Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4998 29.1538C39.1653 29.1538 38.8892 28.8822 38.8892 28.5537V13.1213C38.8892 12.7926 39.1653 12.521 39.4998 12.521C39.8343 12.521 40.1105 12.7926 40.1105 13.1213V28.5393C40.1105 28.868 39.8343 29.1396 39.4998 29.1396V29.1538Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2582 33.3844C45.0983 33.3844 44.9384 33.327 44.822 33.1986C44.575 32.9556 44.5894 32.5698 44.822 32.3411L51.7581 25.6108C52.0054 25.3823 52.3979 25.3823 52.6307 25.6108C52.8632 25.8395 52.8632 26.2396 52.6307 26.4683L45.6945 33.1986C45.5781 33.3128 45.4182 33.3699 45.2582 33.3699V33.3844Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9782 40.7282H48.2681C47.9338 40.7282 47.6575 40.4566 47.6575 40.1279C47.6575 39.7994 47.9338 39.5278 48.2681 39.5278H56.9782C57.3128 39.5278 57.5891 39.7994 57.5891 40.1279C57.5891 40.4566 57.3128 40.7282 56.9782 40.7282Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9323 55.475C51.7721 55.475 51.6122 55.4179 51.4814 55.2892L44.9815 48.6447C44.7489 48.4018 44.7489 48.0159 44.9961 47.7875C45.2434 47.5588 45.6359 47.5588 45.8687 47.8017L52.3683 54.4462C52.6011 54.6891 52.6011 55.075 52.3539 55.3034C52.2375 55.4179 52.0776 55.475 51.9323 55.475Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarquise);
export default __webpack_public_path__ + "static/media/Marquise.099ddaab3bac7db61fd154007a5e5888.svg";
export { ForwardRef as ReactComponent };